import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionFaq のスタイル
 */
export const hotlineLpSectionFaqStyle = tv({
    slots: {
        base: ['w-full max-w-[min(1128px,calc(100%-40px))] mx-auto'],
        item: [],
        itemContent: ['block', 'pt-20 pr-20 pb-20 pl-48', 'text-16 text-[#002F4A]'],
        itemContentWrapper: ['overflow-hidden'],
        itemDetails: ['group/accordion'],
        itemIcon: [
            'flex-shrink-0',
            'relative',
            'w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]',
            'rounded-full',
            'bg-[#4881F1]',
            'border border-solid border-[#4881F1]',
            // 記号部分
            'before:content-[""] after:content-[""]',
            'before:inline-block after:inline-block',
            'before:w-[12px] after:w-[12px]',
            'before:h-[2px] after:h-[2px]',
            'before:bg-[#FFFFFF] after:bg-[#FFFFFF]',
            'before:absolute after:absolute',
            'before:top-1/2 after:top-1/2',
            'before:left-[9px] after:left-[9px] lg:before:left-[13px] lg:after:left-[13px]',
            'before:-transform-y-1/2 after:-transform-y-1/2',
            'before:opacity-100',
            'before:transition-opacity duration-500',
            'after:rotate-90',
            'after:transition-transform duration-500',
            // hover
            'group-hover/accordion:bg-[#FFFFFF]',
            'group-hover/accordion:before:bg-[#4881F1]  group-hover/accordion:after:bg-[#4881F1]',
            'group-hover/accordion:before:opacity-0',
            'group-hover/accordion:after:rotate-180',
            // 開いている時
            'group-open/accordion:bg-[#FFFFFF]',
            'group-open/accordion:before:bg-[#4881F1]  group-open/accordion:after:bg-[#4881F1]',
            'group-open/accordion:before:opacity-0',
            'group-open/accordion:after:rotate-180',
        ],
        itemQuestionHeadText: ['self-start', 'text-24 text-[#4881F1] font-bold'],
        itemQuestionText: ['text-16 text-[#002F4A] font-bold leading-24'],
        itemQuestionTextWrapper: ['flex items-baseline gap-x-16'],
        itemSummary: [
            'flex items-center justify-between gap-x-16',
            'p-20',
            'border-0',
            '[&::marker]:hidden [&::-webkit-details-marker]:hidden list-none',
            // hover
            'hover:cursor-pointer',
            // 開いている時
            'group-open/accordion:border-b group-open/accordion:border-solid group-open/accordion:border-[#D8E6FA]',
        ],
        list: ['mt-36 lg:mt-32', 'flex flex-col gap-y-16'],
    },
});
